import React, {useRef, useEffect, useState} from 'react';
import styled from 'styled-components';
import {Provider} from 'react-redux';
import store from '../redux/store';
import {dynamicImport, preloadComponent} from '../helpers/common';
import {setSchool} from '../redux/actions/common';
import ErrorBoundary from '../components/common/ErrorBoundary';
import Footer from '../components/Footer';


const Questionnaire = dynamicImport(/* #__LOADABLE__ */ () => import(/* webpackChunkName: "Questionnaire" */ '../../app/views/app/Questionnaire'));
Questionnaire.load().then(() => {});


const QuestionnaireWidget = function (props) {
    const questionnaireRef = useRef(null);
    const [isInViewport, setIsInViewport] = useState(false);
    const [isNeedExtraSpace, setNeedExtraSpace] = useState(true);

    useEffect(() => {
        if (window?.locationInfo) {
            store.dispatch(setSchool(window.locationInfo));
        }
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const element = questionnaireRef.current;

            if (element) {
                const rect = element.getBoundingClientRect();
                const isInView = rect.bottom >= 0;
                setIsInViewport(isInView);

                setNeedExtraSpace(window.scrollY < 20);
            }
        };

        window.addEventListener('scroll', handleScroll);

        handleScroll();

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <Provider store={store}>
            <ErrorBoundary boundaryInfo={'app.js App Error'}>
                <div ref={questionnaireRef}>
                    <Questionnaire
                        submitCallback={() => {
                            window.location = '/app/housing-questionnaire-move-in-details';
                        }}
                    />
                </div>

                <FooterSpace style={{ height: isNeedExtraSpace ? 200 : 30 }}/>

                {isInViewport && (
                    <Footer location={{pathname: '/app/housing-questionnaire-your-info'}}/>
                )}
            </ErrorBoundary>
        </Provider>
    );
};

const FooterSpace = styled.div`
    transition: height 0.3s ease;
`;

export default QuestionnaireWidget;

